var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEscudoProtegido = function SvgEscudoProtegido(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 111,
    rx: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.38 92.272h-.477a42.163 42.163 0 0 1-10.75-4.3C32.928 81.285 26 68.626 26 55.249V30.167c0-1.194.717-2.15 1.91-2.628l26.754-8.36c.478-.239.955-.239 1.672 0l26.753 8.36c1.194.24 1.911 1.434 1.911 2.628v25.081c0 17.676-12.182 33.441-28.664 37.263-.717-.477-.955-.239-.955-.239ZM31.256 31.84v23.17c0 11.705 5.972 22.454 15.526 28.425a27.343 27.343 0 0 0 8.6 3.583c13.854-3.583 24.125-16.96 24.125-32.008V31.84l-24.125-7.405-24.126 7.405Z",
    fill: "#0091F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.323 68.38c-.716 0-1.194-.239-1.91-.716l-8.839-8.36c-.955-.956-1.194-2.628 0-3.823.956-.955 2.628-1.194 3.822 0l6.927 6.689 18.393-19.11c.956-.955 2.628-.955 3.822 0 .955.956 1.194 2.628 0 3.822l-20.304 21.02c-.478.24-1.194.478-1.91.478Z",
    fill: "#A3CD50"
  })));
};
export default SvgEscudoProtegido;